import { useNavigate } from 'react-router-dom'
import { Rocket, LogIn, ArrowRight } from 'lucide-react'

export default function OnboardingPage() {
    const navigate = useNavigate()

    return (
        <div className="h-screen bg-white flex flex-col justify-center overflow-hidden font-sans relative">
            {/* Background Decorative Elements */}
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#d4a94d]/5 rounded-full blur-[100px] -mr-40 -mt-40 pointer-events-none"></div>
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#001c28]/5 rounded-full blur-[100px] -ml-40 -mb-40 pointer-events-none"></div>

            <div className="max-w-6xl mx-auto w-full px-4 h-full flex flex-col justify-center animate-in fade-in zoom-in duration-700 relative z-10">
                <div className="text-center mb-8 shrink-0">
                    {/* Pure Logo - SIZE KEPT AS REQUESTED */}
                    <div className="w-56 h-56 mx-auto mb-2">
                        <img src="https://apprub.com.br/space/logo.png" className="w-full h-full object-contain" alt="SpaceRub Logo" />
                    </div>

                    {/* Typography */}
                    <h1 className="text-3xl md:text-4xl font-black text-[#001c28] tracking-tighter uppercase italic leading-tight mb-2">
                        Bem-vindo ao <span className="text-[#001c28]">Space</span><span className="text-[#d4a94d]">Rub</span>
                    </h1>
                    <p className="text-[#001c28] font-bold uppercase tracking-widest text-xs md:text-sm">Como você deseja começar sua jornada?</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-4xl mx-auto px-4 shrink-0">
                    {/* Option: Create */}
                    <button
                        onClick={() => navigate('/create-org')}
                        className="group bg-white p-6 md:p-8 rounded-[2.5rem] shadow-[0_15px_50px_-12px_rgba(0,28,40,0.15)] border-2 border-[#001c28]/5 hover:border-[#d4a94d] transition-all text-left flex flex-col relative overflow-hidden transform hover:-translate-y-1 duration-300 h-full justify-between"
                    >
                        <div className="absolute top-0 right-0 w-24 h-24 bg-[#001c28]/5 rounded-bl-[3rem] -mr-12 -mt-12 group-hover:bg-[#001c28]/10 transition-all"></div>

                        <div>
                            <div className="w-12 h-12 bg-[#001c28] rounded-xl flex items-center justify-center text-[#d4a94d] mb-4 shadow-lg shadow-[#001c28]/20 group-hover:scale-110 transition-transform duration-500">
                                <Rocket className="w-6 h-6" />
                            </div>

                            <h2 className="text-xl font-black text-[#001c28] tracking-tight mb-2">Criar Organização</h2>

                            <p className="text-[#001c28] font-medium text-xs leading-relaxed pr-4">
                                Seja o administrador! Configure espaços, gerencie membros e agilize as reservas.
                            </p>
                        </div>

                        {/* Button */}
                        <div className="mt-6 flex items-center bg-[#d4a94d] text-white font-black uppercase tracking-widest text-[10px] group-hover:bg-[#001c28] transition-colors self-start px-5 py-3 rounded-lg shadow-md shadow-[#d4a94d]/30 group-hover:shadow-[#001c28]/30">
                            Começar Agora <ArrowRight className="w-3 h-3 ml-2 group-hover:translate-x-1 transition-transform" />
                        </div>
                    </button>

                    {/* Option: Join */}
                    <button
                        onClick={() => navigate('/join-org')}
                        className="group bg-white p-6 md:p-8 rounded-[2.5rem] shadow-[0_15px_50px_-12px_rgba(0,28,40,0.15)] border-2 border-[#001c28]/5 hover:border-[#d4a94d] transition-all text-left flex flex-col relative overflow-hidden transform hover:-translate-y-1 duration-300 h-full justify-between"
                    >
                        <div className="absolute top-0 right-0 w-24 h-24 bg-[#d4a94d]/10 rounded-bl-[3rem] -mr-12 -mt-12 group-hover:bg-[#d4a94d]/20 transition-all"></div>

                        <div>
                            <div className="w-12 h-12 bg-[#d4a94d] rounded-xl flex items-center justify-center text-white mb-4 shadow-lg shadow-[#d4a94d]/20 group-hover:scale-110 transition-transform duration-500">
                                <LogIn className="w-6 h-6" />
                            </div>

                            <h2 className="text-xl font-black text-[#001c28] tracking-tight mb-2">Entrar em uma</h2>

                            <p className="text-[#001c28] font-medium text-xs leading-relaxed pr-4">
                                Já recebeu um código? Conecte-se a uma organização existente para fazer reservas.
                            </p>
                        </div>

                        {/* Button */}
                        <div className="mt-6 flex items-center bg-[#d4a94d] text-white font-black uppercase tracking-widest text-[10px] group-hover:bg-[#001c28] transition-colors self-start px-5 py-3 rounded-lg shadow-md shadow-[#d4a94d]/30 group-hover:shadow-[#001c28]/30">
                            Usar Código <ArrowRight className="w-3 h-3 ml-2 group-hover:translate-x-1 transition-transform" />
                        </div>
                    </button>
                </div>
            </div>
        </div>
    )
}
